import { AppState } from 'stores/index'
import { ActiveMunicipalityPath } from 'components/activeMunicipality/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'

function mapStateToProps({ activeMunicipality }: AppState) {
  return {
    activeMunicipality
  }
}

const hideIfNoRegularMunicipality = branch(
  ({ activeMunicipality }: Pick<AppState, 'activeMunicipality'>) =>
    activeMunicipality === '-1',
  renderNothing
)

export default connect(mapStateToProps)(
  hideIfNoRegularMunicipality(ActiveMunicipalityPath)
)
